module.exports = __webpack_public_path__ + "static/media/rom14.396739df.jpg";